import {Size} from '@jetbrains/ring-ui/components/input/input'
import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import Select from '@jetbrains/ring-ui/components/select/select'
import React, {forwardRef} from 'react'

import useEscapeSelectHidePopup from '../../hooks/useEscapeSelectHidePopup'
import styles from '../../MatrixParamBuild.css'

import type {MatrixParamBuildParameterValueProps} from './MatrixParamBuildParameterValue.types'
import useMatrixParamBuildParameterValue from './useMatrixParamBuildParameterValue'

const MatrixParamBuildParameterValue = forwardRef<
  HTMLInputElement,
  MatrixParamBuildParameterValueProps
>(function MatrixParamBuildParameterValue(
  {parameterIndex, index, options = [], value, isDuplicate, isFirst, disabled},
  ref,
) {
  const {
    errorMessage,
    isParameterAutocompletion,
    autocompletionOptions,
    selectChangeHandler,
    selectFilterHandler,
  } = useMatrixParamBuildParameterValue(value, parameterIndex, index, isDuplicate)
  const {pressedEscapePopupStyle, selectKeyDownHandler} = useEscapeSelectHidePopup()
  const isShowBottomHint = isFirst && !errorMessage
  const currentOptions = isParameterAutocompletion ? autocompletionOptions : options

  return (
    <div className={styles.selectRow}>
      <Select
        disabled={disabled}
        type={Select.Type.INPUT}
        size={Size.FULL}
        directions={[Directions.BOTTOM_LEFT]}
        buttonClassName={styles.buttonClassName}
        inputPlaceholder={'Enter parameter value'}
        onKeyDown={selectKeyDownHandler}
        popupStyle={pressedEscapePopupStyle}
        selected={{
          key: value,
          label: value,
        }}
        filter={{
          value,
          fn: selectFilterHandler,
        }}
        filterRef={ref}
        data={currentOptions}
        notFoundMessage={''}
        error={errorMessage}
        popupClassName={styles.popup}
        label={''}
        onChange={selectChangeHandler}
        hideArrow
        allowAny
        clear
      />
      {isShowBottomHint && (
        <div className={styles.hint}>
          {'Format is [OptionalDisplayLabel=>]Value, where Value can contain parameter references'}
        </div>
      )}
    </div>
  )
})

export default MatrixParamBuildParameterValue
